import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnNumberBox from "@shared/components/SnNumberBox";
import SnLabel from "@shared/components/SnLabel";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_STX_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
      grid4: React.createRef(),
      grid5: React.createRef(),
      grid6: React.createRef(),
      grid7: React.createRef(),
      grid8: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
      grid6: [],
      grid7: [],
      grid8: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
      grid4: [],
      grid5: [],
      grid6: [],
      grid7: [],
      grid8: [],
    });

    const [selectedTabPage, setTapPage] = useState<string>("1");
    const [popupParent, setPopupParent] = useState<any>(null);

    const [amK, setAmK] = useState<number>(0);
    const [amVat, setAmVat] = useState<number>(0);
    const [am, setAm] = useState<number>(0);
    const [qt, setQt] = useState<number>(0);

    const getGridCurrent = (key: string): SnGridRef => {
      const grid = gridRefs.current[key]?.current;
      if (!grid) {
        throw new Error(`Grid '${key}' is not mounted yet`);
      }
      return grid;
    };

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let checkValidity = false;
        let selectedRowsH: any[] = [];
        switch (selectedTabPage) {
          case "1":
            selectedRowsH = getGridCurrent("grid1")?.getCheckedRows() || [];
            break;
          case "2":
            selectedRowsH = getGridCurrent("grid3")?.getCheckedRows() || [];
            break;
          case "3":
            selectedRowsH = getGridCurrent("grid5")?.getCheckedRows() || [];
            break;
          case "4":
            selectedRowsH = getGridCurrent("grid7")?.getCheckedRows() || [];
            break;
        }

        let isSame: boolean = false;
        if (selectedRowsH.length > 0) {
          const cdCustValue = selectedRowsH[0].cd_cust;
          const fgTrnsValue = selectedRowsH[0].fg_trns;
          const cdExchValue = selectedRowsH[0].cd_exch;

          isSame = selectedRowsH.every(
            (item: any) =>
              item.cd_cust === cdCustValue &&
              item.fg_trns === fgTrnsValue &&
              item.cd_exch === cdExchValue
          );
        } else {
          checkValidity = true;
        }

        if (!isSame) {
          showDialog(
            "alter",
            "거래처, 거래구분, 환종 정보가 동일한 건만 적용 가능합니다."
          );
        } else {
          checkValidity = true;
        }

        return checkValidity;
      },
      getOkayData: () => {
        let result;
        switch (selectedTabPage) {
          case "1":
            result = [
              getGridCurrent("grid1")?.getCheckedRows() || [],
              getGridCurrent("grid2")?.getCheckedRows() || [],
            ];
            break;
          case "2":
            result = [
              getGridCurrent("grid3")?.getCheckedRows() || [],
              getGridCurrent("grid4")?.getCheckedRows() || [],
            ];
            break;
          case "3":
            result = [
              getGridCurrent("grid5")?.getCheckedRows() || [],
              getGridCurrent("grid6")?.getCheckedRows() || [],
            ];
            break;
          case "4":
            result = [
              getGridCurrent("grid7")?.getCheckedRows() || [],
              getGridCurrent("grid8")?.getCheckedRows() || [],
            ];
            break;
          default:
            result = [[], []];
        }
        return {
          rtnData: result,
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SAL_STX_REG_001_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
            grid3: rtn.grid.grid3,
            grid4: rtn.grid.grid4,
            grid5: rtn.grid.grid5,
            grid6: rtn.grid.grid6,
            grid7: rtn.grid.grid7,
            grid8: rtn.grid.grid8,
          });
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_sal_stx_reg_001_pop_01",
          params: searchRef.current.getFormdata(),
        };

        getGridCurrent("grid1").resetUpdate();
        getGridCurrent("grid2").resetUpdate();
        getGridCurrent("grid3").resetUpdate();
        getGridCurrent("grid4").resetUpdate();
        getGridCurrent("grid5").resetUpdate();
        getGridCurrent("grid6").resetUpdate();
        getGridCurrent("grid7").resetUpdate();
        getGridCurrent("grid8").resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
          grid3: data[2] || [],
          grid4: data[3] || [],
          grid5: data[4] || [],
          grid6: data[5] || [],
          grid7: data[6] || [],
          grid8: data[7] || [],
        });
      } catch (error: any) {}
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid2").setCheckedAll(value);
      } else {
        getGridCurrent("grid2").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid2");
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid2").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid1").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid1").setCheckedFocusedRow(false, "noEvent");
      }
      handleSelectionChange("grid2");
    };

    const onCheckedRowChaged3 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid4").setCheckedAll(value);
      } else {
        getGridCurrent("grid4").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid4");
    };

    const onCheckedRowChaged4 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid4").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid3").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid3").setCheckedFocusedRow(false, "noEvent");
      }
      handleSelectionChange("grid4");
    };

    const onCheckedRowChaged5 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid6").setCheckedAll(value);
      } else {
        getGridCurrent("grid6").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid6");
    };

    const onCheckedRowChaged6 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid6").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid5").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid5").setCheckedFocusedRow(false, "noEvent");
      }
      handleSelectionChange("grid6");
    };

    const onCheckedRowChaged7 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        getGridCurrent("grid8").setCheckedAll(value);
      } else {
        getGridCurrent("grid8").setCheckedAllWithFilter(value);
      }
      handleSelectionChange("grid8");
    };

    const onCheckedRowChaged8 = (value: boolean) => {
      const checkdRows = getGridCurrent("grid8").getCheckedFilteredRows();
      if (checkdRows.length > 0) {
        getGridCurrent("grid7").setCheckedFocusedRow(true, "noEvent");
      } else {
        getGridCurrent("grid7").setCheckedFocusedRow(false, "noEvent");
      }
      handleSelectionChange("grid8");
    };

    const handleSelectionChange = (grid: string) => {
      if (!grid) return;

      const gridRef = getGridCurrent(grid);
      if (!gridRef) return;

      const selectedRows = gridRef.getCheckedRows();
      if (selectedRows.length === 0) {
        setAmK(0);
        setAmVat(0);
        setAm(0);
        setQt(0);
        return;
      }

      const totalAmk = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_k : acc - row.am_k;
      }, 0);

      const totalAmvat = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am_vat : acc - row.am_vat;
      }, 0);

      const totalAm = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.am : acc - row.am;
      }, 0);

      const totalQt = selectedRows.reduce((acc: number, row: any) => {
        return row.fg_io === "1" ? acc + row.qt : acc - row.qt;
      }, 0);

      setAmK(totalAmk);
      setAmVat(totalAmvat);
      setAm(totalAm);
      setQt(totalQt);
    };

    const getRowStyle = (params: any) => {
      if (params.data?.fg_io === "2") {
        return { color: "red" };
      }
      return null;
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {
            onCheckedRowChaged: onCheckedRowChaged3,
          },
        },
        grid4: {
          columns: columns.grid4,
          dataSource: dataSources.grid4,
          events: { onCheckedRowChaged: onCheckedRowChaged4 },
        },
        grid5: {
          columns: columns.grid5,
          dataSource: dataSources.grid5,
          events: {
            onCheckedRowChaged: onCheckedRowChaged5,
          },
        },
        grid6: {
          columns: columns.grid6,
          dataSource: dataSources.grid6,
          events: {
            onCheckedRowChaged: onCheckedRowChaged6,
          },
        },
        grid7: {
          columns: columns.grid7,
          dataSource: dataSources.grid7,
          events: {
            onCheckedRowChaged: onCheckedRowChaged7,
          },
        },
        grid8: {
          columns: columns.grid8,
          dataSource: dataSources.grid8,
          events: { onCheckedRowChaged: onCheckedRowChaged8 },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: "10px",
            margin: "10px 0px 0px 0px",
          }}
        >
          <SnLabel text={"원화합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={amK}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />
          <SnLabel text={"부가세합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={amVat}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />

          <SnLabel text={"총금액합계"} type={"SearchPanel"} />
          <SnNumberBox
            defaultValue={am}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />

          <SnLabel text={"총수량합계"} type={"SearchPanel"} />
          <SnNumberBox defaultValue={qt} isRequired={true} isReadOnly={true} />
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnTab
            titles={["출하번호별", "고객사별", "출하의뢰번호별", "매출처별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid1"]}
                  columnConfig={grids.grid1.columns}
                  rowData={grids.grid1.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid1.events}
                  filter={{
                    refs: [gridRefs.current["grid2"]],
                    columns: ["no_io"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid2.events}
                />
              </div>,

              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid3"]}
                  columnConfig={grids.grid3.columns}
                  rowData={grids.grid3.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid3.events}
                  filter={{
                    refs: [gridRefs.current["grid4"]],
                    columns: ["cd_cust"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid4"]}
                  columnConfig={grids.grid4.columns}
                  rowData={grids.grid4.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid4.events}
                />
              </div>,

              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid5"]}
                  columnConfig={grids.grid5.columns}
                  rowData={grids.grid5.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid5.events}
                  filter={{
                    refs: [gridRefs.current["grid6"]],
                    columns: ["no_req"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid6"]}
                  columnConfig={grids.grid6.columns}
                  rowData={grids.grid6.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid6.events}
                />
              </div>,

              <div className="h-full flex flex-col gap-y-1.5">
                <SnGrid
                  ref={gridRefs.current["grid7"]}
                  columnConfig={grids.grid7.columns}
                  rowData={grids.grid7.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                  }}
                  events={grids.grid7.events}
                  filter={{
                    refs: [gridRefs.current["grid8"]],
                    columns: ["cd_cust_sales"],
                  }}
                />
                <SnGrid
                  ref={gridRefs.current["grid8"]}
                  columnConfig={grids.grid8.columns}
                  rowData={grids.grid8.dataSource}
                  etcProps={{
                    rowSelection: "multiple",
                    ischeckboxSelection: true,
                    popupParent: popupParent,
                    getRowStyle: getRowStyle,
                  }}
                  events={grids.grid8.events}
                />
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_SAL_STX_REG_001_POP_001;
